export default __webpack_public_path__ + "static/media/nights_watch.9badccf6.jpg";